import React from "react";
import { faAward } from "@fortawesome/free-solid-svg-icons";
import ValeurCards from "../sections/ValeurCards";

const Valeur = ({ valeurs }) => {
  if (!valeurs || valeurs.length === 0) {
    return null;
  }

  return (
    <section className="py-24 bg-slate-900 relative overflow-hidden">
        {/* Dark theme dynamic background */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PGRlZnM+PHBhdHRlcm4gaWQ9ImEiIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTTAgMGg0MHY0MEgweiIgZmlsbD0ibm9uZSIvPPHBhdGggZD0iTTIwIDBoMjB2MjBIMjB6TTAgMjBoMjB2MjBIMHoiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wMSkiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjYSkiLz48L3N2Zz4=')] opacity-50 mix-blend-overlay"></div>
        <div className="absolute top-1/4 left-1/4 w-[30rem] h-[30rem] bg-green-500/20 rounded-full mix-blend-screen filter blur-[128px] animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-emerald-600/20 rounded-full mix-blend-screen filter blur-[128px] animate-pulse" style={{ animationDelay: '2s' }}></div>

        <div className="container mx-auto px-4 z-10 relative">
            <div className="text-center mb-16 wow fadeInUp" data-wow-delay="0.1s">
                <span className="text-emerald-400 font-semibold tracking-wider uppercase text-sm mb-2 block">Nos Fondations</span>
                <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight drop-shadow-lg">
                    Nos Valeurs
                </h2>
                <div className="w-24 h-1.5 bg-gradient-to-r from-emerald-400 to-teal-500 mx-auto rounded-full mb-8"></div>
                <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto font-light leading-relaxed">
                    Les principes fondamentaux qui guident nos actions et bâtissent notre culture d'entreprise au quotidien.
                </p>
            </div>
            
            <div className='wow fadeInUp w-full' data-wow-delay="0.2s">
                <ValeurCards data={valeurs} icon={faAward} color={'green'} isDark={true} />
            </div>
        </div>
    </section>
  );
};

export default Valeur;